import React, { useEffect, useState } from "react";
import api from "../api/axios";
import IncomeExpenseChart from "../components/IncomeExpenseChart";

function formatMoney(v) {
  return Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
}

function KpiCard({ title, value, icon, color }) {
  return (
    <div className="col-xl-2 col-md-4 col-sm-6">
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body d-flex align-items-center">
          <div className={`icon-circle bg-${color}-subtle text-${color}`}>
            <i className={`mdi ${icon}`}></i>
          </div>
          <div className="ms-3">
            <div className="text-muted small">{title}</div>
            <div className="fs-4 fw-bold">{/* ₹ */} {formatMoney(value)} <small>QAR</small></div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Dashboard() {

  const [data, setData] = useState({ kpi: {}, ledgers: [] });

  const token = localStorage.getItem("accessToken");

  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  useEffect(() => {
    api.get(`/account-dashboard?branch_id=${branch_id}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      const payload = res.data?.data || { kpi: {}, ledgers: [] };
      setData(payload);
    });
  }, [branch_id]);

  const kpi = data.kpi || {};
  const ledgers = data.ledgers || [];

  //Order by ledger_code
  const sortedLedgers = ledgers.sort((a, b) => {
    return a.ledger_code.localeCompare(b.ledger_code);
  });

  return (
    <>
      {/* HEADER */}
      <div className="row mb-3">
        <div className="col-12">
          <h4 className="fw-semibold">Accounts Dashboard</h4>
        </div>
      </div>

      {/* KPI ROW */}
      <div className="row g-3 mb-4">

        <KpiCard title="Total Balance" value={kpi.total_balance} icon="mdi-wallet" color="primary" />
        {/*  <KpiCard title="Receivable" value={kpi.receivable} icon="mdi-arrow-down-bold-circle" color="success" />
        <KpiCard title="Payable" value={kpi.payable} icon="mdi-arrow-up-bold-circle" color="danger" /> */}

        <KpiCard title="Income" value={kpi.income} icon="mdi-cash-plus" color="success" />
        <KpiCard title="Expense" value={kpi.expense} icon="mdi-cash-minus" color="danger" />

        <KpiCard title="Today Debit" value={kpi.today_debit} icon="mdi-trending-up" color="info" />
        <KpiCard title="Today Credit" value={kpi.today_credit} icon="mdi-trending-down" color="warning" />

      </div>

      <div className="row g-3">

        {/* LEFT: LEDGER TABLE */}
        <div className="col-xl-8">
          <div className="card shadow-sm h-100">
            <div className="card-header">
              <h5 className="mb-0">Accounts Balances</h5>
            </div>

            <div className="card-body p-0 ledger-scroll">
              <table className="table table-hover table-bordered align-middle ledger-table mb-0">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    <th className="text-end">Balance(QAR)</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>

                <tbody>
                  {sortedLedgers.map(l => {

                    const bal = Number(l.balance || 0);

                    return (
                      <tr key={l.ledger_id}>
                        <td>{l.ledger_code}</td>
                        <td>{l.ledger_name}</td>

                        <td className="text-end fw-bold">
                          {formatMoney(Math.abs(bal))}
                          <span className="ms-1 text-muted">
                            {bal > 0 ? "Dr" : bal < 0 ? "Cr" : ""}
                          </span>
                        </td>

                        {/* <td>
                          {bal > 0 && (
                            <span className="badge bg-success">
                              <i className="mdi mdi-arrow-up"></i> Debit
                            </span>
                          )}
                          {bal < 0 && (
                            <span className="badge bg-danger">
                              <i className="mdi mdi-arrow-down"></i> Credit
                            </span>
                          )}
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>

              </table>
            </div>
          </div>
        </div>

        {/* RIGHT: CHART */}
        <div className="col-xl-4">
          <div className="card shadow-sm h-100">
            <div className="card-header">
              <h5 className="mb-0">Income vs Expense</h5>
            </div>

            <div className="card-body d-flex align-items-center justify-content-center">
              <IncomeExpenseChart kpi={kpi} />
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Dashboard;